import { useTranslation } from "react-i18next"
import { Switch, Link, Redirect, Route, useRouteMatch } from "react-router-dom"
import UserListView from "./UserListView"

const UserView = () => {
  const { path, url } = useRouteMatch()
  const { t } = useTranslation()

  const menu = (
    <div className="box">
      <aside className="menu">
        <ul className="menu-list">
          <li>
            <Link to={url + "/list"}>{t("users.list")}</Link>
          </li>
        </ul>
      </aside>
    </div>
  )

  return (
    <>
      <div className="columns">
        <div className="column is-3">{menu}</div>
        <div className="column is-9">
          <Switch>
            <Route exact path={path}>
              <Redirect to={url + "/list"} />
            </Route>
            <Route path={path + "/list"}>
              <UserListView />
            </Route>
          </Switch>
        </div>
      </div>
    </>
  )
}

export default UserView
